<template lang="pug">
v-menu(
  transition="slide-y-transition",
  bottom,
  attach=".suus__reaction__combo__button",
  offset-y,
  v-model="showDropdown"
)
  template(v-slot:activator="{ on, attrs }")
    .suus__reaction__combo__button(:style="reactionButtonStyles")
      ComboActivatorButton(
        :selected="selectedOption",
        :isActive="showDropdown",
        v-bind="attrs",
        v-on="on"
      )
  v-list.pa-0
    v-list-item-group(:value="selectedOptionIndex", color="primary")
      v-list-item(
        v-for="(option, index) in options",
        :key="index",
        v-if="option.name !== 'default'",
        @click="() => selectReaction(option.name)"
      )
        v-list-item-icon.mr-4
          v-icon(
            :size="option.size",
            :color="`${selectedOptionIndex === index ? 'primary' : 'textColor'}`"
          ) {{ option.icon }}
        v-list-item-content 
          v-list-item-title(:style="listItemStyles")
            span {{ option.label }}
</template>

<script lang="ts">
import { ref, computed, defineComponent, PropType } from "vue"
import { Emoji } from "suus-api"
import { EmojiOptionName } from "../../interfaces/emojiOptionName.type"
import useReactionOptions from "../../concerns/useReactionOptions"
import ComboActivatorButton from "./ComboActivatorButton.vue"
import THEME from "../../constants/theme"

export default defineComponent({
  props: {
    selectedReaction: {
      type: String as PropType<Emoji | undefined>,
      required: false,
    },
  },
  components: { ComboActivatorButton },
  computed: {
    reactionButtonStyles(): object {
      return {
        width: this.$vuetify.breakpoint.name === "xs" ? "100%" : "220px",
      }
    },
  },
  setup(props, context) {
    const showDropdown = ref(false)
    const { selectedOption, selectedOptionIndex, options, selectReaction } =
      useReactionOptions({
        source: computed(() => props.selectedReaction),
        createReaction,
        deleteReaction,
        updateReaction,
      })

    function createReaction(newReaction: EmojiOptionName) {
      context.emit("create-reaction", newReaction)
    }
    function deleteReaction(prevReaction: EmojiOptionName) {
      context.emit("delete-reaction", prevReaction)
    }
    function updateReaction(
      prevReaction: EmojiOptionName,
      newReaction: EmojiOptionName
    ) {
      context.emit("update-reaction", { prevReaction, newReaction })
    }

    const { fontFamily, fontWeightRegular } = THEME.typography
    const { textColor } = THEME.colors.light
    return {
      options,
      selectedOptionIndex,
      selectedOption,
      showDropdown,
      selectReaction,
      listItemStyles: {
        fontFamily,
        fontSize: "1rem",
        fontWeight: fontWeightRegular,
        color: textColor,
      },
    }
  },
})
</script>
